// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"405a2f7e","455":"22143dfd","977":"29aab10a"}[chunkId] + ".chunk.js";
};